import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/components/Navbar";

export const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="mx-auto max-w-[1600px] px-4 py-24 sm:px-8 sm:py-32 lg:px-16" data-testid="services-section">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-accent sm:text-sm">{t.services.eyebrow}</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-ink sm:text-5xl">
          {t.services.title}
        </h2>
      </Reveal>

      <div className="mt-16">
        {t.services.items.map((service, i) => (
          <Reveal key={service.id} delay={i * 0.1}>
            <a
              href="#contact"
              onClick={(e) => scrollToSection(e, "contact")}
              className="group grid grid-cols-1 gap-6 border-t border-white/10 py-10 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-12 md:items-center"
              data-testid={`service-row-${service.id}`}
            >
              <span className="font-display text-3xl font-extrabold leading-none text-accent sm:text-4xl md:col-span-1">{service.num}</span>
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-ink transition-colors duration-300 group-hover:text-accent md:col-span-5 sm:text-3xl">
                {service.title}
              </h3>
              <p className="text-sm leading-relaxed text-mist md:col-span-4 sm:text-base">{service.desc}</p>
              <div className="flex items-center justify-between md:col-span-2 md:justify-end md:gap-6">
                <div className="flex flex-wrap gap-2 md:hidden">
                  {service.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-dim">{tag}</span>
                  ))}
                </div>
                <ArrowUpRight className="h-8 w-8 text-dim transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-accent" />
              </div>
              <div className="hidden flex-wrap gap-2 md:col-span-10 md:col-start-2 md:flex">
                {service.tags.map((tag) => (
                  <span key={tag} className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-dim">{tag}</span>
                ))}
              </div>
            </a>
          </Reveal>
        ))}
        <div className="border-t border-white/10" />
      </div>
    </section>
  );
};
